export default __webpack_public_path__ + "static/media/Sakura-petal_0000_Layer-3.2a297b76.png";